<template>
  <div class="content">
    <!-- <base-header class="pb-6">
      <div class="row align-items-center py-2"></div>
    </base-header> -->
    <div class="all-on-borading">
      <!-- <div class="dash-header mb-4">
                    <h2 class="text-default m-0 d-flex">User Onboarding Report <img data-v-2131a5ef="" src="/signup-img/fire.svg" alt=""></h2>
                </div> -->
            <!-- <div class="row align-items-center">
              <div class="col-md-6 col-lg-6">
                <h2 class="mb-3">User Onboarding Report</h2>
              </div>
            </div> -->

        <user-onboarding-report></user-onboarding-report>
    </div>
  </div>
</template>
<script>
import Card from "../../components/Cards/Card.vue";
import UserOnboardingReport from "./UserOnboardingReport.vue";

export default {
  components: {
    UserOnboardingReport,
    Card,
  },
  data() {
    return {};
  },
  created: function () {},
  methods: {},
};
</script>
<style>
.no-border-card .card-footer {
  border-top: 0;
}
</style>
